<template>
  <div class="cp-recipe-item recipe">
    <div class="recipe__inner">
      <div class="recipe__card">
        <div class="recipe__image" v-html="recipe.thumb" />
        <div class="recipe__data">
          <h2 class="recipe__title">{{ recipe.title }}</h2>
          <div class="recipe__author">Publié par {{ recipe.author.name }}</div>
        </div>
        <Favorite :showLabel="false" :recipe="recipe" :round="true" />
        <router-link
          class="recipe__link"
          :to="{ name: 'recipe', params: { slug: recipe.slug } }"
        ></router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Favorite from "../recipe-actions/Favorite.vue";
export default {
  name: "RecipeItem",
  components: { Favorite },
  props: {
    recipe: Object,
  },
  mounted() {},
};
</script>
<style lang="scss">
.recipe {
  text-align: center;
  display: flex;
  flex-direction: column;

  &__inner {
    padding: $gap;
    position: relative;
    min-height: 100%;
    display: flex;
  }
  &__card {
    width: 100%;
    position: relative;
    border-radius: $box-radius;
    overflow: hidden;
    box-shadow: $box-shadow;
    display: flex;
    flex-direction: column;
  }
  &__image {
    display: block;
    & img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  &__data {
    background-color: $white;
    padding: 20px 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  &__title {
    font-size: 22px;
    margin: 0;
    margin-bottom: 5px;
    @include font-title();
  }
  &__link {
    @include absolute(0, 0, 0, 0);
  }
  &__author {
    color: rgb(103, 113, 121);
    margin-top: auto;
  }
  &:hover {
    ::v-deep img {
      filter: grayscale(100);
    }
  }

  .btn {
    position: absolute;
    z-index: 22;
    top: 5px;
    right: 5px;
    width: 2.5em;
    height: 2.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    background: rgba($white, 0.5) !important;
    &.active {
      background: rgba($white, 0.9) !important;
    }
    svg {
      width: 23px;
      height: 23px;
    }
    @include breakpoint(lg-min) {
      transform: translateY(calc(-100% - 10px));
    }
  }
  &:hover .btn {
    transform: translateY(0);
  }
}
</style>
